import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Hoe je carnaval overleeft zonder extra kilo's als souvenir
                </title>
                <link rel="canonical" href={route("blogs.sixty-two")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Ah, carnaval. Die tijd van het jaar waarin we ons hullen in de meest uiteenlopende kostuums, van glinsterende superhelden tot historische figuren met een twijfelachtige nauwkeurigheid. Een periode waarin de calorieën net zo rijkelijk vloeien als de bier en de polonaises langer lijken dan de wachtrij bij de nieuwe attractie in de Efteling. Maar wat als ik je vertel dat je de festiviteiten kunt overleven zonder dat je weegschaal in protest gaat? Hier zijn vijf manieren om carnaval te vieren en toch vrienden te blijven met je broekriem."
                />
                <meta
                    property="og:description"
                    content="Ah, carnaval. Die tijd van het jaar waarin we ons hullen in de meest uiteenlopende kostuums, van glinsterende superhelden tot historische figuren met een twijfelachtige nauwkeurigheid. Een periode waarin de calorieën net zo rijkelijk vloeien als de bier en de polonaises langer lijken dan de wachtrij bij de nieuwe attractie in de Efteling. Maar wat als ik je vertel dat je de festiviteiten kunt overleven zonder dat je weegschaal in protest gaat? Hier zijn vijf manieren om carnaval te vieren en toch vrienden te blijven met je broekriem."
                />
                <meta property="og:url" content={route("blogs.sixty-two")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Hoe je carnaval overleeft zonder extra kilo's als souvenir - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/carnaval-breda-2019.png"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/carnaval-breda-2019.webp"
                                    type="image/webp"
                                    alt="Carnaval"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/carnaval-breda-2019.png"
                                    type="image/png"
                                    alt="Carnaval"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/carnaval-breda-2019.png"
                                    alt="Carnaval"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Hoe je carnaval overleeft zonder extra kilo's als
                        souvenir
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Ah, carnaval. Die tijd van het jaar waarin we ons hullen
                        in de meest uiteenlopende kostuums, van glinsterende
                        superhelden tot historische figuren met een
                        twijfelachtige nauwkeurigheid. Een periode waarin de
                        calorieën net zo rijkelijk vloeien als de bier en de
                        polonaises langer lijken dan de wachtrij bij de nieuwe
                        attractie in de Efteling. Maar wat als ik je vertel dat
                        je de festiviteiten kunt overleven zonder dat je
                        weegschaal in protest gaat? Hier zijn vijf manieren om
                        carnaval te vieren en toch vrienden te blijven met je
                        broekriem.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        1. Dans jezelf slank
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Laten we eerlijk zijn, carnaval zonder dansen is als een
                        café zonder bier. Nutteloos. Dus waarom zou je niet van
                        de nood een deugd maken? Zie elke polonaise als een kans
                        om die calorieën te verbranden. Swing, spring en samba
                        alsof je leven ervan afhangt. Wie weet, misschien ontdek
                        je wel een verborgen talent voor de cha-cha-cha. En het
                        mooiste? Je hebt zo veel plezier dat je vergeet dat je
                        eigenlijk aan het sporten bent.
                    </p>
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        2. Slim snacken
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Tussen al dat hossen en springen door krijg je
                        natuurlijk trek. En hoewel de verleiding groot is om je
                        te storten op een vette hap, zijn er genoeg
                        alternatieven die minstens zo bevredigend zijn. Denk aan
                        een broodje gezond in plaats van een broodje kroket, of
                        een portie vers fruit in plaats van een zak chips. Het
                        klinkt misschien niet zo feestelijk, maar je
                        smaakpapillen (en je taille) zullen je dankbaar zijn.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        3. Hydrateer met beleid
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Bij carnaval hoort natuurlijk een drankje. Of twee. Of
                        drie. Maar wist je dat alcohol bomvol calorieën zit?
                        Probeer daarom af en toe een glas water tussendoor te
                        drinken. Niet alleen houdt het de kater op afstand, maar
                        het helpt ook om je vol te voelen, waardoor je minder
                        geneigd bent om te snacken. En als je echt niet zonder
                        een biertje kunt, overweeg dan een lichtere variant. Je
                        lever zal je dankbaar zijn.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        4. Wees selectief met je feestlocaties
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Niet alle carnavalsfeesten zijn gelijk gemaakt. Sommige
                        plaatsen bieden misschien gezondere voedselopties of
                        meer ruimte om te dansen dan andere. Doe je huiswerk en
                        kies voor locaties waar je weet dat je niet de hele
                        avond aan de bar hoeft te hangen. Wie weet, misschien
                        vind je wel een nieuw favoriet feestje dat zowel leuk
                        als lijnvriendelijk is.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        5. Herinner jezelf aan je doelen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Tussen alle confetti en kostuums door is het makkelijk
                        om te vergeten waarom je ook alweer probeert om niet aan
                        te komen. Hang een herinnering in je kostuum of stel een
                        alarm in op je telefoon als geheugensteuntje. Een kleine
                        herinnering aan je doelen kan net het duwtje in de rug
                        zijn dat je nodig hebt om nee te zeggen tegen dat extra
                        biertje of die zak snoep.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Carnaval is een tijd van ongebreidelde vreugde en
                        feestelijkheid, maar dat betekent niet dat je je
                        gezondheidsdoelen overboord moet gooien. Met een beetje
                        planning en zelfbeheersing kun je zowel het feest als je
                        fitheid volop beleven. Dus trek je meest flamboyante
                        kostuum aan, zet je feestmuts op en bereid je voor om
                        carnaval te vieren op een manier die zowel je hart als
                        je weegschaal zal laten zingen. Proost, en alaaf!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
